// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  color: #1f1f1f;
  font-family: OpenSans;
}

header {
  display: flex;
  padding: 24px 24px 22px;
  position: relative;
  align-items: flex-start;
  justify-content: space-between;
  padding-left: 0;
  padding-right: 12px;
  padding-top: 1rem;
  font-size: 1.5rem;
  font-family: OpenSans-SemiBold;
}

section h2 {
  font-size: 1rem;
  font-family: OpenSans-SemiBold;
}

section p {
  font-size: 0.75rem;
}

mi-report-issue {
  padding-top: 0;
  background-color: transparent;
}

section p a {
  color: blue;
}

.help-text {
  font-size: 14px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJlcG9ydC1pc3N1ZS1tb2RhbC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQTtFQUNFLGNBQUE7RUFDQSxxQkFBQTtBQURGOztBQUlBO0VBQ0UsYUFBQTtFQUNBLHVCQUFBO0VBQ0Esa0JBQUE7RUFDQSx1QkFBQTtFQUNBLDhCQUFBO0VBRUEsZUFBQTtFQUNBLG1CQUFBO0VBQ0EsaUJBQUE7RUFDQSxpQkFBQTtFQUNBLDhCQUFBO0FBRkY7O0FBS0E7RUFDRSxlQUFBO0VBQ0EsOEJBQUE7QUFGRjs7QUFLQTtFQUNFLGtCQUFBO0FBRkY7O0FBS0E7RUFDRSxjQUFBO0VBQ0EsNkJBQUE7QUFGRjs7QUFLQTtFQUNFLFdBQUE7QUFGRjs7QUFLQTtFQUNFLGVBQUE7QUFGRiIsImZpbGUiOiJyZXBvcnQtaXNzdWUtbW9kYWwuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAaW1wb3J0IFwiLi4vLi4vLi4vLi4vZ2xvYmFsLXN0eWxlcy9taXhpbnNcIjtcblxuLmNvbnRhaW5lciB7XG4gIGNvbG9yOiAjMWYxZjFmO1xuICBmb250LWZhbWlseTogT3BlblNhbnM7XG59XG5cbmhlYWRlciB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIHBhZGRpbmc6IDI0cHggMjRweCAyMnB4OyAvLyBjYWxjdWxhdGVSZW0oMjRweCkgY2FsY3VsYXRlUmVtKDI0cHgpIGNhbGN1bGF0ZVJlbSgyMnB4KTtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBhbGlnbi1pdGVtczogZmxleC1zdGFydDtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuXG4gIHBhZGRpbmctbGVmdDogMDtcbiAgcGFkZGluZy1yaWdodDogMTJweDsgLy8gY2FsY3VsYXRlUmVtKDEycHgpO1xuICBwYWRkaW5nLXRvcDogMXJlbTtcbiAgZm9udC1zaXplOiAxLjVyZW07XG4gIGZvbnQtZmFtaWx5OiBPcGVuU2Fucy1TZW1pQm9sZDtcbn1cblxuc2VjdGlvbiBoMiB7XG4gIGZvbnQtc2l6ZTogMXJlbTtcbiAgZm9udC1mYW1pbHk6IE9wZW5TYW5zLVNlbWlCb2xkO1xufVxuXG5zZWN0aW9uIHAge1xuICBmb250LXNpemU6IDAuNzVyZW07XG59XG5cbm1pLXJlcG9ydC1pc3N1ZSB7XG4gIHBhZGRpbmctdG9wOiAwO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB0cmFuc3BhcmVudDtcbn1cblxuc2VjdGlvbiBwIGEge1xuICBjb2xvcjogYmx1ZTtcbn1cblxuLmhlbHAtdGV4dCB7XG4gIGZvbnQtc2l6ZTogMTRweDsgLy8gY2FsY3VsYXRlUmVtKDE0cHgpO1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/modules/report-problem/components/report-issue-modal/report-issue-modal.component.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;EACA,qBAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;EACA,8BAAA;EAEA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,8BAAA;AAFF;;AAKA;EACE,eAAA;EACA,8BAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,cAAA;EACA,6BAAA;AAFF;;AAKA;EACE,WAAA;AAFF;;AAKA;EACE,eAAA;AAFF;AACA,omDAAomD","sourcesContent":["// @import \"../../../../global-styles/mixins\";\n\n.container {\n  color: #1f1f1f;\n  font-family: OpenSans;\n}\n\nheader {\n  display: flex;\n  padding: 24px 24px 22px; // calculateRem(24px) calculateRem(24px) calculateRem(22px);\n  position: relative;\n  align-items: flex-start;\n  justify-content: space-between;\n\n  padding-left: 0;\n  padding-right: 12px; // calculateRem(12px);\n  padding-top: 1rem;\n  font-size: 1.5rem;\n  font-family: OpenSans-SemiBold;\n}\n\nsection h2 {\n  font-size: 1rem;\n  font-family: OpenSans-SemiBold;\n}\n\nsection p {\n  font-size: 0.75rem;\n}\n\nmi-report-issue {\n  padding-top: 0;\n  background-color: transparent;\n}\n\nsection p a {\n  color: blue;\n}\n\n.help-text {\n  font-size: 14px; // calculateRem(14px);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
